module.exports = __webpack_public_path__ + "static/shelton-ct-line-drawing-65254072e5347ef276f1c056129d0288.svg";